var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopLeftQuarterCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 63,
    viewBox: "0 0 53 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5222 6.556C50.5222 18.4172 48.298 27.5485 44.3645 34.6046C40.4429 41.6393 34.7355 46.7681 27.4947 50.5014C12.8677 58.0427 -7.86335 59.8269 -32.1802 59.8269C-55.7976 59.8269 -74.1056 50.497 -86.5532 35.3532C-99.0425 20.1587 -105.759 -1.05404 -105.759 -24.9356C-105.759 -48.806 -99.0518 -67.8082 -86.6661 -80.8292C-74.2967 -93.8332 -55.9867 -101.163 -32.1802 -101.163C-8.93147 -101.163 11.7066 -86.4449 26.6523 -65.3452C41.5829 -44.2669 50.5222 -17.2181 50.5222 6.556Z",
    stroke: "url(#paint0_linear_1598_1945)",
    strokeWidth: 4.70903
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1598_1945",
    x1: -110.13,
    y1: -95.6385,
    x2: 70.354,
    y2: -74.2794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30004A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182505,
    stopColor: "#480F67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387169,
    stopColor: "#561C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593487,
    stopColor: "#72279B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888568,
    stopColor: "#BE68EC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLeftQuarterCircle);
export default __webpack_public_path__ + "static/media/TopLeftQuarterCircle.1db44d9b.svg";
export { ForwardRef as ReactComponent };